// 테스트 데이터: 알림 Popper UI 테스트를 위한 더미 데이터 생성
// notify-popper 컴포넌트 내부에서 테스트 모드를 활성화/비활성화할 수 있습니다
// local/dev 환경에서만 notify-header의 메뉴를 통해 제어 가능합니다

// 기본 사용자 정보
const baseUser = {
    name: "유현우",
    id: "D9E0m6dAZkHR2nZzhwgFooke",
    isDeleted: false,
    isWithdrawal: false,
    username: "hyunyoo@mz.co.kr",
};

const baseUser2 = {
    id: "yJYgaH1WmvqBAlDrxkwxJ2iq",
    isDeleted: false,
    isWithdrawal: false,
    name: "홍인지",
    username: "ingnoh@mz.co.kr",
};

// 기본 프로젝트 정보
const baseProject = {
    id: "Oj63TAud2DwZ1a2i95Zzva0I",
    name: "[CrossAccount] Singapore",
    description: null,
    status: "COMPLETE",
    expiredAt: null,
    isActive: true,
    isDeleted: false,
    isIntegratedSearchable: false,
    createdAt: "2025-08-26 04:39:37",
    createdById: "System",
    createdByName: "System",
    createdByUsername: "System",
    updatedAt: "2025-09-19 05:43:29",
    updatedById: "D9E0m6dAZkHR2nZzhwgFooke",
    updatedByName: "유현우",
    updatedByUsername: "hyunyoo@mz.co.kr",
    ownerId: "System",
    ownerName: "System",
    ownerUsername: "System",
    region: "ap-southeast-1",
};

const baseProject2 = {
    id: "WUmxy8UVwUz7tlv4yQrATLlc",
    name: "Dev",
    description: "목록 툴팁 테스트입니다.목록 툴팁 테스트입니다.목록 툴팁 테스트입니다.목록 툴팁 테스트입니다.",
    status: "COMPLETE",
    expiredAt: null,
    isActive: true,
    isDeleted: false,
    isIntegratedSearchable: false,
    createdAt: "2024-11-28 06:37:31",
    createdById: "tfNRxI1ZT0OjdJmkKYaGcQJa",
    createdByName: "이교준",
    createdByUsername: "kyojun@mz.co.kr",
    updatedAt: "2025-09-19 06:31:11",
    updatedById: "D9E0m6dAZkHR2nZzhwgFooke",
    updatedByName: "유현우",
    updatedByUsername: "hyunyoo@mz.co.kr",
    ownerId: "tfNRxI1ZT0OjdJmkKYaGcQJa",
    ownerName: "이교준",
    ownerUsername: "kyojun@mz.co.kr",
    region: "ap-northeast-2",
};

// 현재 시간 기준으로 상대적 시간 생성
const getRelativeTime = (minutesAgo) => {
    const date = new Date();
    date.setMinutes(date.getMinutes() - minutesAgo);
    return date.toISOString();
};

// 케이스 1: 알림이 없는 경우
export const generateEmptyNotifications = () => {
    return [];
};

// 케이스 2: 읽지 않은 알림만 있는 경우
export const generateUnreadOnlyNotifications = () => {
    return [
        {
            topicId: "topic-1",
            traceId: "trace-1",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(5),
            data: {
                type: "MENTIONED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-1",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(5),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(5),
                        },
                    },
                    thread: {
                        id: "thread-1",
                        name: "Asset 관련 논의",
                        type: "PUBLIC",
                        context: {
                            domain: "ASSET",
                            resourceId: "asset-1",
                            metadata: {
                                name: "sample-video.mp4",
                                mediaType: "VIDEO",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(10),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-2",
            traceId: "trace-2",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(30),
            data: {
                type: "MENTIONED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-2",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(30),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(30),
                        },
                    },
                    thread: {
                        id: "thread-2",
                        name: null,
                        type: "PRIVATE",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-2",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-2",
                                name: "컬렉션 검토",
                                context: {
                                    domain: "COLLECTION",
                                    resourceId: "collection-1",
                                    metadata: {
                                        name: "2024 광고 컬렉션",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(30),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
    ];
};

// 케이스 3: 읽은 알림만 있는 경우
export const generateReadOnlyNotifications = () => {
    return [
        {
            topicId: "topic-3",
            traceId: "trace-3",
            status: "READ",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(120),
            data: {
                type: "MENTIONED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-3",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(120),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(120),
                        },
                    },
                    thread: {
                        id: "thread-3",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "REQUEST",
                            resourceId: "request-1",
                            metadata: {
                                title: "다운로드 권한 요청",
                                category: "Download permission",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(150),
                            by: baseUser,
                        },
                    },
                },
            },
        },
    ];
};

// 케이스 4: 읽은/읽지 않은 알림이 섞인 경우
export const generateMixedStatusNotifications = () => {
    return [
        {
            topicId: "topic-4",
            traceId: "trace-4",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(10),
            data: {
                type: "INVITED",
                project: baseProject,
                resource: {
                    invited: {
                        at: getRelativeTime(10),
                        by: baseUser2,
                    },
                    thread: {
                        id: "thread-4",
                        name: "프로젝트 논의 스레드",
                        type: "PRIVATE",
                        context: {
                            domain: "PROJECT",
                            resourceId: baseProject2.id,
                            metadata: {
                                name: baseProject2.name,
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(100),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-5",
            traceId: "trace-5",
            status: "READ",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(60),
            data: {
                type: "MENTIONED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-5",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(60),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(60),
                        },
                    },
                    thread: {
                        id: "thread-5",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "ASSET",
                            resourceId: "4m6oHcwokFEwGeqNWev4Q01m",
                            metadata: {
                                name: "runningman.mp4",
                                mediaType: "AUDIO",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(80),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-6",
            traceId: "trace-6",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(90),
            data: {
                type: "REPLIED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-6",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(90),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(90),
                        },
                    },
                    thread: {
                        id: "thread-6",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-6",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-6",
                                name: null,
                                context: {
                                    domain: "CUSTOM_CONTENT",
                                    resourceId: "custom-1",
                                    metadata: {
                                        name: "커스텀 콘텐츠 1",
                                        contentSchemaName: "Product Info",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(90),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
    ];
};

// 케이스 5: 모든 타입(MENTIONED, REPLIED, INVITED)이 섞인 경우
export const generateAllTypesNotifications = () => {
    return [
        {
            topicId: "topic-7",
            traceId: "trace-7",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(5),
            data: {
                type: "MENTIONED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-7",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(5),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(5),
                        },
                    },
                    thread: {
                        id: "thread-7",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "ASSET",
                            resourceId: "asset-3",
                            metadata: {
                                name: "promotional-image.jpg",
                                mediaType: "IMAGE",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(20),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-7-2",
            traceId: "trace-7-2",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(10),
            data: {
                type: "MENTIONED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-7-2",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(10),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(10),
                        },
                    },
                    thread: {
                        id: "thread-7-2",
                        name: "이미지 검토 스레드",
                        type: "PRIVATE",
                        context: {
                            domain: "ASSET",
                            resourceId: "asset-3-2",
                            metadata: {
                                name: "banner-design.jpg",
                                mediaType: "IMAGE",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(100),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-8",
            traceId: "trace-8",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(15),
            data: {
                type: "REPLIED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-8",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(15),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(15),
                        },
                    },
                    thread: {
                        id: "thread-8",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-8",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-8",
                                name: null,
                                context: {
                                    domain: "COLLECTION",
                                    resourceId: "collection-2",
                                    metadata: {
                                        name: "Summer Campaign",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(15),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-9",
            traceId: "trace-9",
            status: "READ",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(45),
            data: {
                type: "INVITED",
                project: baseProject,
                resource: {
                    invited: {
                        at: getRelativeTime(45),
                        by: baseUser,
                    },
                    thread: {
                        id: "thread-9",
                        name: "Private Discussion",
                        type: "PRIVATE",
                        context: {
                            domain: "PROJECT",
                            resourceId: baseProject2.id,
                            metadata: {
                                name: baseProject2.name,
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(100),
                            by: baseUser,
                        },
                    },
                },
            },
        },
    ];
};

// 케이스 6: 모든 domain(ASSET, COLLECTION, REQUEST, CUSTOM_CONTENT, PROJECT)이 섞인 경우
export const generateAllDomainsNotifications = () => {
    return [
        {
            topicId: "topic-10",
            traceId: "trace-10",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(5),
            data: {
                type: "MENTIONED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-10",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(5),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(5),
                        },
                    },
                    thread: {
                        id: "thread-10",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "ASSET",
                            resourceId: "asset-4",
                            metadata: {
                                name: "corporate-video.mp4",
                                mediaType: "VIDEO",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(20),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-11",
            traceId: "trace-11",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(15),
            data: {
                type: "REPLIED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-11",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(15),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(15),
                        },
                    },
                    thread: {
                        id: "thread-11",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-11",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-11",
                                name: null,
                                context: {
                                    domain: "COLLECTION",
                                    resourceId: "collection-3",
                                    metadata: {
                                        name: "Marketing Assets 2024",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(15),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-12",
            traceId: "trace-12",
            status: "READ",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(30),
            data: {
                type: "MENTIONED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-12",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(30),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(30),
                        },
                    },
                    thread: {
                        id: "thread-12",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "REQUEST",
                            resourceId: "request-2",
                            metadata: {
                                title: "에셋 사용 권한 요청",
                                category: "Common",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(60),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-13",
            traceId: "trace-13",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(50),
            data: {
                type: "INVITED",
                project: baseProject2,
                resource: {
                    invited: {
                        at: getRelativeTime(50),
                        by: baseUser2,
                    },
                    thread: {
                        id: "thread-13",
                        name: "Project Discussion",
                        type: "PRIVATE",
                        context: {
                            domain: "PROJECT",
                            resourceId: baseProject.id,
                            metadata: {
                                name: baseProject.name,
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(100),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-13-2",
            traceId: "trace-13-2",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(55),
            data: {
                type: "MENTIONED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-16",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(5),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(5),
                        },
                    },
                    thread: {
                        id: "thread-16",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "PROJECT",
                            resourceId: baseProject2.id,
                            metadata: {
                                name: baseProject2.name,
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(10),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-14",
            traceId: "trace-14",
            status: "READ",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(70),
            data: {
                type: "REPLIED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-14",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(70),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(70),
                        },
                    },
                    thread: {
                        id: "thread-14",
                        name: null,
                        type: "PRIVATE",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-14",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-14",
                                name: "Product 카탈로그 논의",
                                context: {
                                    domain: "CUSTOM_CONTENT",
                                    resourceId: "custom-2",
                                    metadata: {
                                        name: "Product Catalog Item",
                                        contentSchemaName: "Catalog Schema",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(70),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-15",
            traceId: "trace-15",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(90),
            data: {
                type: "REPLIED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-15",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(90),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(90),
                        },
                    },
                    thread: {
                        id: "thread-15",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-15",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-1",
                                name: null,
                                context: {
                                    domain: "ASSET",
                                    resourceId: "asset-5",
                                    metadata: {
                                        name: "nested-comment-asset.jpg",
                                        mediaType: "IMAGE",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(120),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
    ];
};

// 케이스 7: ASSET의 모든 mediaType(VIDEO, AUDIO, CAPTION, FILE, IMAGE, TEXT)을 포함하는 경우
export const generateAllAssetMediaTypesNotifications = () => {
    return [
        {
            topicId: "topic-16",
            traceId: "trace-16",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(5),
            data: {
                type: "MENTIONED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-16",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(5),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(5),
                        },
                    },
                    thread: {
                        id: "thread-16",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "ASSET",
                            resourceId: "asset-video-1",
                            metadata: {
                                name: "promotional-video.mp4",
                                mediaType: "VIDEO",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(10),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-17",
            traceId: "trace-17",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(15),
            data: {
                type: "REPLIED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-17",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(15),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(15),
                        },
                    },
                    thread: {
                        id: "thread-17",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-17",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-17",
                                name: "Audio Asset Discussion",
                                context: {
                                    domain: "ASSET",
                                    resourceId: "asset-audio-1",
                                    metadata: {
                                        name: "background-music.mp3",
                                        mediaType: "AUDIO",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(15),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-18",
            traceId: "trace-18",
            status: "READ",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(25),
            data: {
                type: "MENTIONED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-18",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(25),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(25),
                        },
                    },
                    thread: {
                        id: "thread-18",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "ASSET",
                            resourceId: "asset-caption-1",
                            metadata: {
                                name: "subtitle-korean.srt",
                                mediaType: "CAPTION",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(40),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-19",
            traceId: "trace-19",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(35),
            data: {
                type: "REPLIED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-19",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(35),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(35),
                        },
                    },
                    thread: {
                        id: "thread-19",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-19",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-19",
                                name: null,
                                context: {
                                    domain: "ASSET",
                                    resourceId: "asset-file-1",
                                    metadata: {
                                        name: "project-document.pdf",
                                        mediaType: "FILE",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(35),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-20",
            traceId: "trace-20",
            status: "READ",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(45),
            data: {
                type: "MENTIONED",
                project: baseProject2,
                resource: {
                    comment: {
                        id: "comment-20",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(45),
                            by: baseUser,
                        },
                        updated: {
                            at: getRelativeTime(45),
                        },
                    },
                    thread: {
                        id: "thread-20",
                        name: null,
                        type: "PUBLIC",
                        context: {
                            domain: "ASSET",
                            resourceId: "asset-image-1",
                            metadata: {
                                name: "banner-design.jpg",
                                mediaType: "IMAGE",
                            },
                            parentThread: null,
                        },
                        created: {
                            at: getRelativeTime(60),
                            by: baseUser,
                        },
                    },
                },
            },
        },
        {
            topicId: "topic-21",
            traceId: "trace-21",
            status: "UNREAD",
            receiverId: "receiver-1",
            receivedAt: getRelativeTime(55),
            data: {
                type: "REPLIED",
                project: baseProject,
                resource: {
                    comment: {
                        id: "comment-21",
                        isDeleted: false,
                        created: {
                            at: getRelativeTime(55),
                            by: baseUser2,
                        },
                        updated: {
                            at: getRelativeTime(55),
                        },
                    },
                    thread: {
                        id: "thread-21",
                        name: null,
                        type: "PRIVATE",
                        context: {
                            domain: "COMMENT",
                            resourceId: "comment-21",
                            metadata: {},
                            parentThread: {
                                id: "parent-thread-21",
                                name: "Text Asset Comments",
                                context: {
                                    domain: "ASSET",
                                    resourceId: "asset-text-1",
                                    metadata: {
                                        name: "script-content.txt",
                                        mediaType: "TEXT",
                                    },
                                },
                            },
                        },
                        created: {
                            at: getRelativeTime(55),
                            by: baseUser2,
                        },
                    },
                },
            },
        },
    ];
};

// 테스트용 프로젝트 목록
export const generateTestProjects = () => {
    return [
        baseProject,
        baseProject2,
        {
            id: "temp",
            name: "아무것도 없는 더미 프로젝트",
        },
    ];
};

// 모든 테스트 케이스를 포함하는 함수
export const getAllTestNotifications = () => {
    return {
        empty: generateEmptyNotifications(),
        unreadOnly: generateUnreadOnlyNotifications(),
        readOnly: generateReadOnlyNotifications(),
        mixedStatus: generateMixedStatusNotifications(),
        allTypes: generateAllTypesNotifications(),
        allDomains: generateAllDomainsNotifications(),
        allAssetMediaTypes: generateAllAssetMediaTypesNotifications(),
    };
};
